import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import axios from 'axios';
import { fetchMidstockList } from "./MidstockListPostRedux";
import { fetchPengalihanList } from "./OrderListRedux";

interface MidstockAddPostState {
  midstockAddDraft: {
    midstockId: string,
    amountToAdd: number,
    message?: string,
    processesData?: any,
    // Dedup id generated per dialog-open (see components/stockRequestId.ts).
    requestId?: string,
  },

  dialogOpen: boolean,

  dialogExpectedAddOpen: boolean
  dialogInProgressAddOpen: boolean
  dialogInProgressFinishOpen: boolean

  dialogPengalihanOpen: boolean
  midstockPengalihanDraft: {
    creationDateTime: string,
    midstockId: string,
    midstockIdTarget: string,
    amountToAdd: number,
    message: string,
  },

  dialogRequestMaterialOpen: boolean
  requestMaterialMidstockId: string

  status: APIRequestStatus,
  // Separate status for pengalihan OPEN/CLOSE/CANCEL so their buttons can disable
  // while a request is in flight (the server is double-click-safe, this fixes the UX).
  pengalihanActionStatus: APIRequestStatus,
  error: string | null,
}

const initialState: MidstockAddPostState = {
    midstockAddDraft: {
        midstockId: '',
        amountToAdd: 0,
    },

    dialogOpen: false,

    dialogExpectedAddOpen: false,
    dialogInProgressAddOpen: false,
    dialogInProgressFinishOpen: false,

    dialogPengalihanOpen: false,
    midstockPengalihanDraft: {
      creationDateTime: '',
      midstockId: '',
      midstockIdTarget: '',
      amountToAdd: 0,
      message: '',
    },

    dialogRequestMaterialOpen: false,
    requestMaterialMidstockId: '',

    status: APIRequestStatus.Idle,
    pengalihanActionStatus: APIRequestStatus.Idle,
    error: ''
}

const slice = createSlice({
    name: 'midstockStockAdd',
    initialState,
    reducers: {
        updateVal(state, action) {
          state.midstockAddDraft = action.payload;
          console.log(`State values: ${JSON.stringify(state.midstockAddDraft)}`);
        },
        updateValPengalihan(state, action) {
          state.midstockPengalihanDraft = action.payload;
          console.log(`State values: ${JSON.stringify(state.midstockAddDraft)}`);
        },
        updateDialogOpen(state, action) {
          state.dialogOpen = action.payload;
        },
        updateDialogExpectedAddOpen(state, action) {
          state.dialogExpectedAddOpen = action.payload;
        },
        updateDialogInProgressAddOpen(state, action) {
          state.dialogInProgressAddOpen = action.payload;
        },
        updateDialogInProgressFinishOpen(state, action) {
          state.dialogInProgressFinishOpen = action.payload;
        },
        updateDialogRequestMaterialOpen(state, action) {
          state.dialogRequestMaterialOpen = action.payload;
        },
        updateDialogPengalihanOpen(state, action) {
          state.dialogPengalihanOpen = action.payload;
        },
        updateRequestMaterialId(state, action) {
          state.requestMaterialMidstockId = action.payload;
        }
    },
    extraReducers(builder) {
        builder
          .addCase(postMidstockStockAdd.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
          })
          .addCase(postMidstockStockAdd.fulfilled, (state, action) => {
            // We only close the dialog if the post is successful
            if (action.payload.success) {
              state.dialogOpen = false;
            }

            state.status = APIRequestStatus.Success;
            console.log("Post success.");
          })
          .addCase(postMidstockStockAdd.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            console.log("Post failed.");
          })
          .addCase(postMidstockStockAddPayload.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
          })
          .addCase(postMidstockStockAddPayload.fulfilled, (state, action) => {
            // We only close the dialog if the post is successful
            if (action.payload.success) {
              state.dialogOpen = false;
              state.dialogExpectedAddOpen = false;
              state.dialogInProgressAddOpen = false;
              state.dialogInProgressFinishOpen = false;
            }

            state.status = APIRequestStatus.Success;
            console.log("Post success.");
          })
          .addCase(postMidstockStockAddPayload.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            console.log("Post failed.");
          })
          .addCase(postMidstockWorkStockFinish.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
          })
          .addCase(postMidstockWorkStockFinish.fulfilled, (state, action) => {
            // We only close the dialog if the post is successful
            if (action.payload.success) {
              state.dialogOpen = false;
              state.dialogInProgressAddOpen = false;
              state.dialogInProgressFinishOpen = false;
            }

            state.status = APIRequestStatus.Success;
            console.log("Post success.");
          })
          .addCase(postMidstockWorkStockFinish.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            console.log("Post failed.");
          })
          .addCase(postMidstockRequestMaterial.pending, (state, action) => {
          })
          .addCase(postMidstockRequestMaterial.fulfilled, (state, action) => {
            state.dialogRequestMaterialOpen = false;
            state.requestMaterialMidstockId = '';
          })
          .addCase(postMidstockRequestMaterial.rejected, (state, action) => {
          })
          .addCase(postMidstockPengalihanOpen.pending, (state, action) => {
            state.pengalihanActionStatus = APIRequestStatus.RequestInProgress;
          })
          .addCase(postMidstockPengalihanOpen.fulfilled, (state, action) => {
            state.pengalihanActionStatus = APIRequestStatus.Success;
            state.dialogPengalihanOpen = false;
            state.midstockPengalihanDraft = {
              creationDateTime: '',
              midstockId: '',
              midstockIdTarget: '',
              amountToAdd: 0,
              message: '',
            };
          })
          .addCase(postMidstockPengalihanOpen.rejected, (state, action) => {
            state.pengalihanActionStatus = APIRequestStatus.Failure;
          })
          .addCase(postMidstockPengalihanCloseOrCancel.pending, (state, action) => {
            state.pengalihanActionStatus = APIRequestStatus.RequestInProgress;
          })
          .addCase(postMidstockPengalihanCloseOrCancel.fulfilled, (state, action) => {
            state.pengalihanActionStatus = APIRequestStatus.Success;
          })
          .addCase(postMidstockPengalihanCloseOrCancel.rejected, (state, action) => {
            state.pengalihanActionStatus = APIRequestStatus.Failure;
          })
      }
})

export const postMidstockStockAdd = createAsyncThunk('midstockStockAdd/postMidstockStockAdd', async (arg, thunkAPI) => {
    const state: any = thunkAPI.getState();

    const response = await axios({
      method: 'post',
      url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/midstock/add',
      data: state.midstockStockAdd.midstockAddDraft,
    });

    if (response.data?.rejected === "COGS_BELUM_RESOLVE") {
      window.alert(response.data?.message
      // The backend explains why (midstock unused / product cost 0) once deployed.
      ? "DITOLAK: " + response.data.message + " (Stok TIDAK diubah.)"
      : "DITOLAK: cogs " + (response.data?.midstockId ?? "SKU ini") +
        " belum ter-resolve (produk baru?). Stok TIDAK diubah — isi cogs produk dulu, lalu coba lagi.");
    }

    thunkAPI.dispatch(fetchMidstockList());

    return response.data
})

export const postMidstockStockAddPayload = createAsyncThunk('midstockStockAdd/postMidstockStockAddPayload', async (arg: any, thunkAPI) => {
  const state: any = thunkAPI.getState();

  const response = await axios({
    method: 'post',
    url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/midstock/add',
    data: arg,
  });

  if (response.data?.rejected === "COGS_BELUM_RESOLVE") {
    window.alert(response.data?.message
      // The backend explains why (midstock unused / product cost 0) once deployed.
      ? "DITOLAK: " + response.data.message + " (Stok TIDAK diubah.)"
      : "DITOLAK: cogs " + (response.data?.midstockId ?? "SKU ini") +
      " belum ter-resolve (produk baru?). Stok TIDAK diubah — isi cogs produk dulu, lalu coba lagi.");
  }

  thunkAPI.dispatch(fetchMidstockList());

  return response.data
})

export const postMidstockWorkStockFinish = createAsyncThunk('midstockStockAdd/postMidstockWorkStockFinish', async (arg: any, thunkAPI) => {
    const state: any = thunkAPI.getState();

    const response = await axios({
      method: 'post',
      url: 'https://8mav2hp6ki.execute-api.ap-southeast-1.amazonaws.com/OrderAPIProduction/work-stock-finish',
      data: {
        description: 'Penyelesaian stok ' + arg.midstockId + ' sebanyak ' + arg.amountToAdd,
        resultDict: {
          ['ms-' + arg.midstockId]: arg.amountToAdd,
        },
        processesData: arg.processesData,
        processesExecutors: arg.processesExecutors,
      },
    });

    thunkAPI.dispatch(fetchMidstockList());

    return response.data
})

export const postMidstockRequestMaterial = createAsyncThunk('midstockStockAdd/postMidstockRequestMaterial', async (arg: string, thunkAPI) => {

  const currentTs = new Date().getTime();

  const response = await axios({
    method: 'put',
    url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/midstock',
    data: {
      midstockId: arg,
      item_01_material_request_time: new Date(currentTs).toISOString(),
      item_02_material_arrive_time: new Date(currentTs + 7 * 24 * 60 * 60 * 1000).toISOString(),
      item_03_restock_standard_time: new Date(currentTs + 10 * 24 * 60 * 60 * 1000).toISOString(),
    },
  });

  thunkAPI.dispatch(fetchMidstockList());

  return response.data
})

export const postMidstockPengalihanOpen = createAsyncThunk('midstockStockAdd/postMidstockPengalihanOpen', async (arg: any, thunkAPI) => {
  const state: any = thunkAPI.getState();

  const response = await axios({
    method: 'post',
    url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/midstock/add',
    data: arg,
  });

  thunkAPI.dispatch(fetchMidstockList());

  return response.data
})
export const postMidstockPengalihanCloseOrCancel = createAsyncThunk('midstockStockAdd/postMidstockPengalihanCloseOrCancel', async (arg: any, thunkAPI) => {
  const state: any = thunkAPI.getState();

  const response = await axios({
    method: 'post',
    url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/midstock/add',
    data: arg,
  });

  thunkAPI.dispatch(fetchPengalihanList());

  return response.data
})

export const { updateVal, updateValPengalihan, updateDialogPengalihanOpen, updateDialogOpen, updateDialogInProgressAddOpen, updateDialogExpectedAddOpen, updateDialogInProgressFinishOpen, updateDialogRequestMaterialOpen, updateRequestMaterialId } = slice.actions

export default slice.reducer